import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";

export default class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error("Error caught in error boundary", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			console.log("Error boundary", this.props);
			return (
				<div className={`z-50 fixed top-0 left-0 right-0 bottom-0 bg-white`}>
					<div
						className={
							"mx-auto h-full flex flex-col justify-center items-center"
						}
					>
						<div className={"flex justify-center"}>
							<h1 className={"inline-block mx-auto text-center"}>
								<span
									className={
										"font-bold text-black text-4xl md:text-5xl leading-none block"
									}
								>
									Your Health Companion
								</span>
							</h1>
						</div>
						<div
							className={`flex flex-col justify-center items-center text-center text-black p-3 rounded-xl`}
						>
							<p className={"pb-2"}>Sorry, an error has occurred.</p>
							<p className={"pb-2"}>
								This normally occurs when the connection to the internet is
								lost.
							</p>
							<p className={"pb-2"}>
								Any data you were recording may have been lost.
							</p>
							<p className={"pb-2"}>
								Please make sure that you have a good connection and then try
								again.
							</p>
							<p className={"pb-2"}>
								If this problem presists, please contact our helpdesk at
								help@health-companion.me, quoting reference '#GE001'.
							</p>
							<button
								className={
									"my-auto text-center text-white bg-app-charcoal mt-12 px-3 py-2 rounded-lg text-base"
								}
								onClick={() => {
									this.setState({ hasError: false });
									// this.props.history && this.props.history.push(this.props.goToPath || "/") || window.location.reload();
									this.props.history.push("/dashboard");
								}}
							>
								{this.props.label ?? "Press to return to the main screen"}
							</button>
						</div>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

ErrorBoundary.contextType = DiseaseGroupContext;

export const ErrorBoundaryWithRouter = withRouter(ErrorBoundary);
